<template>
  <div class="app-container" v-show="isLogin">
    <div class="czjl">
      <div style="margin-top: 20px">
        一次性充值<span class="blueSpan">50</span>金币, 免费升级为<span class="blueSpan"
          >一级VIP</span
        >.
      </div>
      <div>
        一次性充值<span class="blueSpan">200</span>金币, 免费升级为<span class="blueSpan"
          >二级VIP</span
        >
      </div>
      <div>
        一次性充值<span class="blueSpan">300</span>金币, 免费升级为<span class="blueSpan"
          >三级VIP</span
        >
      </div>
      <div>
        一次性充值<span class="blueSpan">500</span>金币, 免费升级为<span class="blueSpan"
          >四级VIP</span
        >
      </div>
      <div v-show="!isShow">
        一次性充值<span class="blueSpan">800</span>金币, 免费升级为<span class="blueSpan"
          >五级VIP</span
        >
      </div>
      <div v-show="isShow">
        一次性充值<span class="blueSpan">80000</span>金币, 免费升级为<span class="blueSpan"
          >五级VIP</span
        >
      </div>
    </div>
    <br />
    <div
      style="
        margin-top: -214px;
        height: 20px;
        width: 100px;
        font-size: 18px;
        margin-left: 30px;
        padding-left: 13px;
        background-color: white;
      "
    >
      充值奖励
    </div>
    <!-- 订单记录 -->
    <div style="text-align: left; margin-top: 200px">
      <div class="filter-container" style="margin-bottom: 10px">
        <el-table
          v-loading="listLoading"
          :data="list"
          highlight-current-row
          style="color: rgb(70, 70, 70); margin-top: 10px"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '3px 0' }"
          :header-cell-style="{
            background: 'rgb(247 248 252) !important',
            color: '#ededed  !important',
            padding: '7px 0',
            color: 'rgb(140, 140, 140)',
          }"
        >
          <el-table-column label="快递名称" align="left" min-width="4">
            <template slot-scope="{ row }">
              <span class="ellipsis" :title="row.desc_name">{{ row.desc_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="零售价" min-width="1" align="left">
            <template slot-scope="{ row }">
              <span>{{ row.member[1] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="一级会员" min-width="1" align="left">
            <template slot-scope="{ row }">
              <span>{{ row.member[2] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="二级会员" min-width="1" align="left">
            <template slot-scope="{ row }">
              <span>{{ row.member[3] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="三级会员" min-width="1" align="left">
            <template slot-scope="{ row }">
              <span>{{ row.member[4] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="四级会员" min-width="1" align="left">
            <template slot-scope="{ row }">
              <span>{{ row.member[5] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="五级会员" min-width="1" align="left">
            <template slot-scope="{ row }">
              <span>{{ row.member[6] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker } from "element-ui";
import axios from "axios";
import Cookies from "js-cookie";
import waves from "@/directive/waves"; // waves directive
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination

export default {
  name: "hyjg",
  components: {
    Pagination,
    "el-date-picker": DatePicker,
  },
  directives: { waves },
  data() {
    return {
      list: [],
      isLogin: false,
      isShow: false,
    };
  },
  created() {
    const system_id = Cookies.get("view_system_id");
    if (system_id == "44" || system_id == 44) {
      this.isShow = true;
    }
    //判断 登录userToken是否有效 userToken == '' ||
    const userToken = Cookies.get("view_userToken");

    if (userToken == undefined) {
      this.isLogin = false;
      this.$confirm("请先登录再使用！", "提示", {
        confirmButtonText: "确定",
      })
        .then(() => {
          // 重新导航到登录页面
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/login" });
        })
        .catch(() => {
          // 重新导航到首页
          localStorage.clear();
          this.$root.removeCookies();
          this.$router.push({ path: "/" });
        });
      return;
    } else {
      this.isLogin = true;
    }
    this.getList();
  },
  methods: {
    async getList() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        this.isLogin = false;
        this.$confirm("请先登录再使用！", "提示", {
          confirmButtonText: "确定",
        })
          .then(() => {
            // 重新导航到登录页面
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/login" });
          })
          .catch(() => {
            // 重新导航到首页
            localStorage.clear();
            this.$root.removeCookies();
            this.$router.push({ path: "/" });
          });
        return;
      }

      this.list = [];
      // this.memberList = [];
      this.listLoading = true;
      const url = this.$root.commonPreUrl + "/index/cangAndMember";
      const token = Cookies.get("view_userToken");
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == 200) {
            this.list = resd.data.cang;
            this.list.forEach((item, index) => {
              item.member = JSON.parse(item.member);
            });
            //  this.memberList = resd.data.member;
            this.listLoading = false;
          }
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          if (
            JSON.stringify(error).includes("Error: Request failed with status code 401")
          ) {
            this.$confirm("登录信息已失效，请重新登录!", "提示", {
              confirmButtonText: "确认",
              showCancelButton: false, //是否显示取消按钮
            })
              .then(() => {
                // 重新导航到首页
                localStorage.clear();
                this.$root.removeCookies();
                this.$router.push({ path: "/login" });
              })
              .catch(() => {});
          }

          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 3 * 1000);
    },
  },
};
</script>

<style>
@import "vue2-datepicker/index.css";

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 87%;
  vertical-align: middle;
}
.czjl {
  width: 80vw;
  height: 180px;
  border: #dcdfe6 1px solid;
  padding-left: 15px;
  text-align: left;
}
.czjl div {
  /* height: 30px; */
  margin-top: 10px;
}
.blueSpan {
  color: #0850fc;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/cwmx/hyjg/index.vue